const constants = {
    API_URL_DEV: 'http://127.0.0.1:5000',
    API_URL_PROD: 'https://aws-backend.kenai-ltimindtree.com:5000',
};

export default constants;